module.exports = __webpack_public_path__ + "img/longBG.21346050.png";